export const SET_AVAILABILITY_RESPONSE = 'SET_AVAILABILITY_RESPONSE'
export const SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED = 'SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED'
export const SET_IS_FETCHING_FOR_AVAILABILITY = 'SET_IS_FETCHING_FOR_AVAILABILITY'

export const mutations = {
  [SET_AVAILABILITY_RESPONSE]: function (state, payload) {
    state.availabilityResponse = payload
  },
  [SET_IS_AT_LEAST_ONE_CHECKBOX_CHECKED]: function (state, payload) {
    state.isAtLeastOneCheckboxChecked = payload
  },
  [SET_IS_FETCHING_FOR_AVAILABILITY]: function (state, payload) {
    state.isFetchingForAvailability = payload
  },
}
